import { gql } from '@grandvisionhq/graphql';
import { cartDetails } from '../fragments/cart-details.js';
import { cartValidationErrors } from '../fragments/cart-validation-errors.js';

const ADD_CART_VOUCHER_CODES = gql`
  mutation AddCartVoucherCodes($cartInput: CartVoucherCodesInput!) {
    addCartVoucherCodes(cartInput: $cartInput) {
      cart {
        ...CartDetailsFragment
      }
      validationErrors {
        ...CartValidationErrorsFragment
      }
      success
      failures {
        __typename

        ... on Failure {
          message
        }

        ... on VoucherCodeNotApplicableFailure {
          message
          code
          reason
          voucherCode
        }
      }
    }
  }
  ${cartDetails}
  ${cartValidationErrors}
`;

export { ADD_CART_VOUCHER_CODES };
//# sourceMappingURL=add-cart-voucher-codes.js.map
